import {Directive, Input, TemplateRef} from "@angular/core";

@Directive({
  selector: 'ng-template[intTabsAction]'
})
export class IntTabsActionDirective {
  @Input() intTabsAction: string | null = null;

  constructor(readonly templateRef: TemplateRef<any>) {
  }
}
